var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMenuCircleTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 416,
    viewBox: "0 0 465 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0396 184.377C42.186 140.872 61.6386 100.607 93.104 69.1547C130.156 32.0895 179.421 11.6903 231.818 11.6903C284.216 11.6903 333.468 32.0895 370.52 69.1547C401.985 100.62 421.438 140.872 426.584 184.377L437.624 178.99C423.571 77.8877 336.788 0.0507812 231.818 0.0507812C126.849 0.0507812 40.0394 77.8877 26 178.99L37.0396 184.363V184.377ZM426.384 232.922C420.958 275.827 401.585 315.478 370.52 346.557C333.481 383.596 284.216 404.008 231.818 404.008C179.421 404.008 130.169 383.596 93.1173 346.557C62.0386 315.478 42.666 275.813 37.2396 232.908L26.1467 237.655C40.5994 338.304 127.183 415.648 231.818 415.648C336.454 415.648 423.038 338.304 437.477 237.655L426.384 232.908V232.922Z",
    fill: "url(#paint0_linear_318_2458)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M231.819 409.956C137.982 409.956 58.5588 348.825 31.8398 264.535C56.5189 351.745 136.702 415.636 231.819 415.636C326.935 415.636 407.105 351.745 431.784 264.535C405.065 348.825 325.642 409.956 231.819 409.956Z",
    fill: "url(#paint1_linear_318_2458)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0396 184.375C42.186 140.87 61.6386 100.605 93.104 69.1531C130.156 32.0879 179.421 11.6887 231.818 11.6887C284.216 11.6887 333.468 32.0879 370.52 69.1531C401.985 100.618 421.438 140.87 426.584 184.375L431.864 181.802C426.224 137.79 406.332 97.112 374.453 65.2199C336.348 27.1147 285.696 6.12891 231.818 6.12891C177.941 6.12891 127.276 27.1147 89.1842 65.2066C57.2921 97.0986 37.3862 137.79 31.7598 181.802L37.0396 184.375ZM426.384 232.92C420.958 275.825 401.585 315.477 370.52 346.555C333.481 383.594 284.216 404.006 231.818 404.006C179.421 404.006 130.169 383.594 93.1173 346.555C62.0386 315.477 42.666 275.812 37.2395 232.907L31.9331 235.186C37.7862 278.705 57.6121 318.903 89.1842 350.489C127.289 388.594 177.954 409.566 231.818 409.566C285.683 409.566 336.348 388.58 374.453 350.489C406.025 318.917 425.837 278.705 431.691 235.186L426.384 232.92Z",
    fill: "url(#paint2_linear_318_2458)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M431.784 151.151C407.105 63.9416 326.921 0.0507812 231.819 0.0507812C136.716 0.0507812 56.5189 63.9416 31.8398 151.151C58.5588 66.8748 137.982 6.3172 231.819 6.3172C325.655 6.3172 405.065 66.8615 431.784 151.151Z",
    fill: "url(#paint3_linear_318_2458)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5413 232.976C21.277 220.165 17.1042 209.3 17.1042 209.3C17.1042 209.3 20.2638 198.675 37.3413 184.437L26.3029 179.051C26.3029 179.051 12.8782 190.942 0 208.42C12.8782 225.911 26.4362 237.709 26.4362 237.709L37.528 232.963L37.5413 232.976Z",
    fill: "url(#paint4_linear_318_2458)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0487 181.85L26.3029 179.051C26.3029 179.051 12.8782 190.942 0 208.42C12.8782 225.911 26.4362 237.709 26.4362 237.709L32.2221 235.243C15.1445 219.645 6.70571 208.007 6.70571 208.007C17.4908 190.729 32.0487 181.85 32.0487 181.85Z",
    fill: "url(#paint5_linear_318_2458)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70703 208.008C6.70703 208.008 15.1325 219.646 32.2234 235.244L37.5293 232.978C22.1182 221.406 17.0922 209.301 17.0922 209.301C16.9189 209.181 13.1728 208.021 6.70703 208.008Z",
    fill: "url(#paint6_linear_318_2458)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0487 181.85C31.6088 182.237 17.3175 190.996 6.70571 208.007C6.70571 208.007 3.0529 208.833 0 208.42C12.6782 191.209 25.8363 179.411 26.3029 179.051C26.3029 179.051 32.0621 181.85 32.0487 181.85Z",
    fill: "url(#paint7_linear_318_2458)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M426.646 232.976C442.911 220.165 447.084 209.3 447.084 209.3C447.084 209.3 443.924 198.675 426.846 184.437L437.885 179.051C437.885 179.051 451.31 190.942 464.188 208.42C451.31 225.911 437.752 237.709 437.752 237.709L426.66 232.963L426.646 232.976Z",
    fill: "url(#paint8_linear_318_2458)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432.125 181.85L437.884 179.051C437.884 179.051 451.309 190.942 464.187 208.42C451.309 225.911 437.751 237.709 437.751 237.709L431.965 235.243C449.042 219.658 457.481 208.007 457.481 208.007C446.709 190.729 432.138 181.85 432.138 181.85H432.125Z",
    fill: "url(#paint9_linear_318_2458)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M457.467 208.008C457.467 208.008 449.041 219.646 431.95 235.244L426.645 232.978C442.656 220.313 447.082 209.301 447.082 209.301C447.255 209.181 451.001 208.021 457.467 208.008Z",
    fill: "url(#paint10_linear_318_2458)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M432.125 181.85C432.565 182.237 446.856 190.996 457.468 208.007C457.468 208.007 461.121 208.833 464.174 208.42C451.509 191.209 438.351 179.411 437.884 179.051C437.884 179.051 432.125 181.85 432.138 181.85H432.125Z",
    fill: "url(#paint11_linear_318_2458)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_2458",
    x1: 231.805,
    y1: 0.0507812,
    x2: 231.805,
    y2: 415.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_2458",
    x1: 231.805,
    y1: 264.535,
    x2: 231.805,
    y2: 415.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_2458",
    x1: 231.805,
    y1: 409.566,
    x2: 231.805,
    y2: 6.12891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_2458",
    x1: 231.805,
    y1: 151.165,
    x2: 231.805,
    y2: 0.0507812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_2458",
    x1: 18.7706,
    y1: 405.312,
    x2: 18.7706,
    y2: 13.8878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_2458",
    x1: 16.1177,
    y1: 57.5882,
    x2: 16.1177,
    y2: 374.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_2458",
    x1: 22.1315,
    y1: 200.516,
    x2: 22.1315,
    y2: 242.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_2458",
    x1: 87.4675,
    y1: 287.849,
    x2: 45.9934,
    y2: 234.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_2458",
    x1: 445.417,
    y1: 179.051,
    x2: 445.417,
    y2: 179.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_2458",
    x1: 448.069,
    y1: 57.5882,
    x2: 448.069,
    y2: 374.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_2458",
    x1: 442.069,
    y1: 179.052,
    x2: 442.069,
    y2: 179.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_2458",
    x1: 376.72,
    y1: 287.849,
    x2: 418.194,
    y2: 234.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMenuCircleTwo);
export default __webpack_public_path__ + "static/media/quick-menu-circle-two.5fd148c44672faea75d73e94dcd30459.svg";
export { ForwardRef as ReactComponent };